module.exports = __webpack_public_path__ + "media/apps/gif-android-12-10d9c0f6.gif";